export const TIMEOUT_DELAY = 1000;
export const DEFAULT_SEARCH_PARAMS = {
  q: {
    name: '',
    service_type_ids: [],
  },
};
